/** Mezőnevek több küldeményhez: 1. slot a suffix nélküli kulcs, 2+ a `shipment2Type` stílus. */
export function shipmentKey(baseKey, idx) {
  if (idx === 0) return baseKey;
  const n = idx + 1;
  switch (baseKey) {
    case 'shipmentType':
      return `shipment${n}Type`;
    case 'packagingDesc':
      return `packaging${n}Desc`;
    case 'contentDesc':
      return `content${n}Desc`;
    case 'weightKg':
      return `weight${n}Kg`;
    case 'lengthCm':
      return `length${n}Cm`;
    case 'widthCm':
      return `width${n}Cm`;
    case 'heightCm':
      return `height${n}Cm`;
    case 'note':
      return `note${n}`;
    default:
      return `${baseKey}${n}`;
  }
}

export function buildShipmentsArray(form, shipmentCount) {
  const buildShipmentEntry = (idx) => {
    const typeK = shipmentKey('shipmentType', idx);
    const packagingK = shipmentKey('packagingDesc', idx);
    const contentK = shipmentKey('contentDesc', idx);
    const weightK = shipmentKey('weightKg', idx);
    const lengthK = shipmentKey('lengthCm', idx);
    const widthK = shipmentKey('widthCm', idx);
    const heightK = shipmentKey('heightCm', idx);
    const noteK = shipmentKey('note', idx);
    return {
      type: form[typeK] || '',
      packaging: form[packagingK] || '',
      content: form[contentK] || '',
      weightKg: form[weightK] || '',
      lengthCm: form[lengthK] || '',
      widthCm: form[widthK] || '',
      heightCm: form[heightK] || '',
      note: form[noteK] || '',
    };
  };
  const shipments = [];
  for (let i = 0; i < shipmentCount; i += 1) {
    shipments.push(buildShipmentEntry(i));
  }
  return shipments;
}

export function apiShipmentFromFirst(first) {
  return {
    type: first.type,
    packaging: first.packaging,
    content: first.content,
    weightKg: first.weightKg,
    sizeCm: [first.lengthCm, first.widthCm, first.heightCm].filter(Boolean).join(' x '),
    lengthCm: first.lengthCm,
    widthCm: first.widthCm,
    heightCm: first.heightCm,
    note: first.note,
  };
}
